import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { IDocument, IPolicy, IPolicyApplication } from '../../../../../../data/api/models';
import { destroy, formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { actions as authActions, IAuthActions } from '../../../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../../../services/branding/reducer';
import { IQuoteActions, IQuoteState } from '../../../../../../services/quote/models';
import { IAuthState } from '../../../../../../services/auth/models';
import { Button, Table } from 'react-bootstrap';
import { FiDownload, FiEye } from 'react-icons/fi';
import { find, flow, forEach, get, startCase, toLower } from 'lodash';
import PolicyDetailHelper from '../../policyDetailHelper';
import { Promise } from 'es6-promise';
import Loading from '../../../../../../components/Loading';
import { withJob } from 'react-jobs';
import Heap from '../../../../../../helpers/Heap';
import { paymentMethodActions } from '../../../../../../services/paymentMethod/actions';
import { IPaymentMethodActions } from '../../../../../../services/paymentMethod/models';
import DownloadDocumentsButton from '../../../Components/DowloadDocumentsButton/DownloadDocumentsButton';
import { ApplicationDetailsBanner } from '../../../Components/ApplicationDetailsBanner';
import { GoBack } from '../../../Components/GoBack';
import { format } from 'date-fns';

interface IDocumentsArea {
  quote: IQuoteState;
  auth: IAuthState;
  history: any;
  actions: {
    auth: IAuthActions;
    paymentMethod: IPaymentMethodActions;
    push: (route: string) => void;
    quote: IQuoteActions;
    destroy(formName: string);
  };
}

interface IDocumentsAreaStates {
  loading: boolean;
}

class DocumentsArea extends React.Component<IDocumentsArea, IDocumentsAreaStates> {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    }

    this.initTracking();
  }

  private initTracking = () => {
    const { auth, actions } = this.props;
    const policy = this.getSelectedPolicy();
    Heap.trackPolicyDocumentEvent(
      'PolicyDocumentPage',
      policy,
      get(auth, 'customer.marketingOptions'),
      actions.paymentMethod.getPolicyPaymentMethod(get(policy, 'assignedPaymentMethods')),
    );
  }

  private getSelectedPolicy = () => {
    const { auth } = this.props;
    let policy = null;
    forEach(auth.customer.policies, (policySelected) => {
      if (location.pathname.match(policySelected.id)) {
        policy = policySelected;
      }
    });
    return policy;
  }

  private getSelectedQuote(applications: IPolicyApplication[]) {
    let selectedQuote = null;

    forEach(applications, (quoteSelected) => {
      if (location.pathname.match(quoteSelected.id)) {
        selectedQuote = quoteSelected;
      }
    });

    return selectedQuote;
  }

  public sortByDocumentType = (documents: IDocument[], sortOrder: string[]) => {
    const ordering = {};
    for (let i = 0; i < sortOrder.length; i++) {
      ordering[sortOrder[i]] = i;
    }

    return documents.sort((a, b) => {
      return (ordering[a.documentType] - ordering[b.documentType]);
    });
  }

  public renderQuoteDocumentsTable = (selectedQuote) => {
    const documents = selectedQuote.documents;

    const quoteDocumentsSortOrder = [
      'Quotation',
      'Additional Renewal Letter',
      'Medical Declaration',
    ];
    const quoteDocuments = this.sortByDocumentType(documents.filter((document: IDocument) => {
      return quoteDocumentsSortOrder.includes(document.documentType);
    }), quoteDocumentsSortOrder);

    const policyDocumentsSortOrder = [
      'Policy Wording',
      'Terms of Business Customer Agreement',
    ];
    const policyDocuments = this.sortByDocumentType(documents.filter((document: IDocument) => {
      return policyDocumentsSortOrder.includes(document.documentType);
    }), policyDocumentsSortOrder);

    return (
      <>
        {this.renderDocuments(quoteDocuments, ['Quote Information', 'Description', 'Date'], 'quote', selectedQuote.id)}
        {this.renderIPIDs(selectedQuote, 'quote', selectedQuote.id)}
        {this.renderDocuments(policyDocuments, ['Policy Documents', 'Description', 'Date'])}
      </>
    );
  }

  private getDocumentDescription = (documentType) => {
    if (documentType === 'Policy Wording') {
      return 'This is the full policy wording for you to review';
    }
    if (documentType === 'Medical Declaration') {
      return 'This shows all the medical conditions that have been declared';
    }
    if (documentType === 'Policy Holder Letter') {
      return 'This displays key information about your insurance policy and what to do next';
    }
    if (documentType === 'Terms of Business Customer Agreement') {
      return 'A full list of all of our terms and conditions';
    }
    if (documentType === 'Certificate') {
      return 'A full detail of what you are covered for as well as excesses and upgrades';
    }
    if (documentType === 'Insurance Product Information Document') {
      return 'Document summarising the key features of your insurance policy';
    }
    if (documentType === 'Quotation') {
      return 'This is the quotation letter for you to review';
    }
    if (documentType === 'Additional Renewal Letter') {
      return 'Renewal Letter';
    }
  }

  private mapDisplayName = (documentType, displayName) => {
    if (documentType === 'Terms of Business Customer Agreement') {
      return 'Your Agreement with EUI Limited';
    }

    return displayName;
  }

  public renderPolicyDocumentsTable = (policy) => {
    const sortOrder = [
      'Policy Holder Letter',
      'Certificate',
      'Medical Declaration',
      'Insurance Product Information Document',
      'Policy Wording',
      'Terms of Business Customer Agreement',
    ];
    const documents = this.sortByDocumentType(policy.documents, sortOrder);

    return this.renderDocuments(documents, [
      'Document Name',
      'Description',
      'Date',
    ], 'policy', policy.id);
  }

  private renderIPIDs = (selectedQuote: IPolicyApplication, type: string, resourceId: string) => {
    const premiums = PolicyDetailHelper.sortPremiums(selectedQuote);
    const ipids = [];
    premiums.forEach((premium) => {
      const filePath = premium.scheme.documents['Insurance Product Information Document'];
      const document = find(selectedQuote.documents, ['filePath', filePath])
      const ipid = {
        coverLevel: premium.scheme.coverLevel,
        filePath,
        id: get(document, 'id'),
        name: 'Insurance-Product-Information-Document'
      };
      ipids.push(ipid);
    });

    const ipidsCount = ipids.length;
    if (!ipidsCount) {
      return null;
    }

    return (
      <div className="admiral-table mb-20">
        <Table>
          <thead>
          <tr>
            <th data-sm-show="show">Insurance Product Information Documents</th>
            <th/>
            <th/>
          </tr>
          </thead>
          <tbody>
          {ipids.map((ipid, index) => {
            return (
              <tr key={index} className="documents">
                <td className="w-3">
                  {startCase(toLower(ipid.coverLevel))} Insurance Product Information Document
                </td>
                <td className={'document-description'}/>
                <td className="w-7">
                  <div className={'download-container'}>
                    <div className="view">
                      <a href={ipid.filePath} target="_blank" className="document-area__download"><FiEye/> </a>
                    </div>
                    <div className="document-area__download dynamic download-file">
                      <FiDownload
                        onClick={this.handleDownloadDocument(ipid.id, type, resourceId, ipid.name, false)}/>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
          </tbody>
        </Table>
      </div>
    );
  }

  private renderDocuments = (documents: IDocument[], headers: string[], type?: string, resourceId?: string) => {
    if (!documents.length) {
      return null;
    }

    return (
      <div className="admiral-table mb-20">
        <Table>
          <thead>
          <tr>
            {headers.map((value, index) => {
              return (
                <th data-sm-show="show" id={value} key={index}><h3>{value}</h3></th>
              );
            })}
            <th/>
          </tr>
          </thead>
          <tbody>
          {documents.map((document, key) => {
            if (document.documentType !== 'Additional Renewal Letter') {
              return (
                <tr key={key} className="documents">
                  <td className="w-3">{this.mapDisplayName(document.documentType, document.displayName)}</td>
                  <td className="document-description">{this.getDocumentDescription(document.documentType)}</td>
                  <td className="date w-7">{format(new Date(document.createdAt), 'dd/MM/yyyy')}</td>
                  {document.filePath && (

                    <td className="w-7">
                      <div className={'download-container'}>
                        <div className="view">
                          <a href={document.filePath} target="_blank" className="document-area__download"><FiEye/> </a>
                        </div>
                        <div className="document-area__download dynamic download-file">
                          <FiDownload
                            onClick={this.handleDownloadDocument(document.id, type, resourceId, document.name, false)}/>
                        </div>
                      </div>
                    </td>
                  )}
                  {!document.filePath && (
                    <>
                      <td className="w-7">
                        <div className={'download-container'}>
                          <div className="document-area__download dynamic view"><FiEye
                            onClick={this.handleDownloadDocument(document.id, type, resourceId, document.name, true)}/>
                          </div>
                          <div className="document-area__download dynamic download-file"><FiDownload
                            onClick={this.handleDownloadDocument(document.id, type, resourceId, document.name, false)}/>
                          </div>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              );
            }
          })}
          </tbody>
        </Table>
      </div>
    );
  }

  private handleDownloadDocument = (documentId: string, type: string, resourceId: string, documentName: string, view: boolean) => () => {
    const { actions } = this.props;
    this.setState({ loading: true })
    Promise.resolve(actions.auth.downloadDocument(documentId, type, resourceId, documentName, view)).then(() => {
      this.setState({ loading: false })
    });
  }

  private renderBanner = (policy, selectedQuote) => {
    if (policy) {
      const tripType = policy && startCase(toLower(policy.metadata.scheme_type));
      const text = `Policy Reference: ${policy.policyNumber}`;
      const isAnnual = tripType.toLowerCase() === 'annual'
      const HeaderText = isAnnual ? 'Annual Trip' : 'Single Trip';

      return (
        <ApplicationDetailsBanner
          tripType={tripType.toLowerCase()}
          text={text}
          headerText={HeaderText}
        />
      );
    }

    if (selectedQuote) {
      const tripType = selectedQuote && startCase(toLower(selectedQuote.tripType));
      const text = `Quote Reference: ${selectedQuote.quoteReference}`;
      const isAnnual = tripType.toLowerCase() === 'annual'
      const HeaderText = isAnnual ? 'Annual Trip' : 'Single Trip';

      return (
        <ApplicationDetailsBanner
          tripType={tripType.toLowerCase()}
          text={text}
          headerText={HeaderText}
        />
      );
    }
  }

  private handleReloadDocuments = () => {
    const { actions } = this.props;
    this.setState({ loading: true })
    Promise.resolve(actions.auth.reloadCustomer()).then(() => {
      this.setState({ loading: false })
    });
  }

  public render() {
    const { auth, history } = this.props;
    const { loading } = this.state;

    let policy: IPolicy = null;
    let isDisplayingPolicy = false;

    forEach(auth.customer.policies, (policySelected) => {
      if (location.pathname.match(policySelected.id)) {
        policy = policySelected;
        isDisplayingPolicy = true;
      }
    });

    let selectedQuote = this.getSelectedQuote(auth.customer.renewals);

    if (!selectedQuote) {
      selectedQuote = this.getSelectedQuote(auth.customer.policyApplications);
    }

    const isRenewal = get(selectedQuote, 'renewal', false);

    if (!policy && !selectedQuote) {
      return null;
    }

    return (
      <div className="document-area">
        <h2><strong>{'Your Documents'}</strong></h2>
        <div className="mb-20">
          {this.renderBanner(policy, selectedQuote)}
        </div>

        <div className={'documents-header-container'}>
          <div className={'d-h-text'}>
            <p><b>Note:</b> If you have just made an amendment, please wait a few minutes for the documents to be
              updated and then reload them from the button.</p>
          </div>
          <div className={'d-h-buttons'}>
            {isDisplayingPolicy && (
              <>
                <div className={'documents-download-button'}>
                  <DownloadDocumentsButton policy={policy} disabled={loading}/>
                </div>
                <div style={{ marginTop: '15px' }}>
                  <Button
                    className="full-width functional-button"
                    bsStyle="primary"
                    block={true}
                    disabled={loading}
                    onClick={this.handleReloadDocuments}>
                    RELOAD DOCUMENTS
                  </Button>
                </div>
              </>
            )}

            {!isDisplayingPolicy && (
              <>
                {isRenewal && (
                  <div style={{ marginBottom: '15px' }}>
                    <DownloadDocumentsButton renewal={selectedQuote} disabled={loading}/>
                  </div>
                )}
                <Button className="functional-button"
                        bsStyle="primary"
                        block={true}
                        onClick={this.handleReloadDocuments}>
                  RELOAD DOCUMENTS
                </Button>
              </>
            )}

          </div>
        </div>

        {loading && (
          <Loading/>
        )}

        {!loading && (
          <>
            <div style={{ marginTop: '15px' }}/>
            {!isDisplayingPolicy && this.renderQuoteDocumentsTable(selectedQuote)}
            {isDisplayingPolicy && this.renderPolicyDocumentsTable(policy)}
          </>
        )}

        <div style={{ marginTop: '15px' }}/>
        <GoBack history={history}/>
      </div>
    );

  }
}

let selector;
export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  withJob({
    work: (props: IDocumentsArea) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());

      return Promise.all(promises);
    },
    LoadingComponent: () => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const groupType = selector(state, 'groupType');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const destinationsValue = selector(state, 'destinations');
      const occupationValue = selector(state, 'occupations');
      const industryValue = selector(state, 'industries');
      const region = selector(state, 'region');
      const maxTripDuration = selector(state, 'maxTripDuration');

      return {
        tripType,
        region,
        maxTripDuration,
        groupType,
        startDate,
        endDate,
        destinationsValue,
        occupationValue,
        industryValue,
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(DocumentsArea);
